<template>
  <main class="text-white relative z-30">
    <div class="how !ml-12 md:!ml-auto">
      <div
        class="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-5xl"
      >
        <img
          src="../assets/images/caddie-min.png"
          class="absolute hidden top-20 w-48 md:block lg:w-80 -left-48 lg:-top-20 lg:-left-[340px]"
        />
      </div>

      POUR PARTICIPER :
      <ul class="mt-2">
        <li class="relative mb-2">
          <span class="points">1</span>
          JE SCANNE LE QR CODE PRÉSENT SUR UN SUPPORT DE COMMUNICATION EN
          MAGASIN.<br />
          <small
            >J’ai la possibilité de me pré-inscrire en cliquant sur le bouton «
            Je n’ai pas encore effectué mes achats »</small
          >
        </li>
        <li class="relative mb-2">
          <span class="points">2</span>
          J'ACHÈTE DEUX PRODUITS PARTICIPANTS** ET JE CONSERVE MON TICKET DE
          CAISSE.
        </li>
        <li class="relative">
          <span class="points">3</span>
          JE PARTICIPE EN CLIQUANT SUR LE BOUTON «JE PARTICIPE» ET JE DÉCOUVRE
          DIRECTEMENT SI J'AI GAGNÉ.
        </li>
      </ul>
    </div>

    <div class="w-full text-center mt-6 font-veneer">
      <!--<button class="m-auto">JE PARTICIPE</button>
        <button class="m-auto my-6">
          je n’ai pas encore effectué mes achats
        </button> -->
      <router-link :to="{ path: '/form', query: $route.query }"
        ><span class="btn block m-auto my-6">je participe</span></router-link
      >
      <router-link to="/later"
        ><span class="btn block m-auto my-6"
          >je n’ai pas encore effectué mes achats</span
        ></router-link
      >
    </div>

    <p
      class="text-sm w-[90%] text-left max-w-xl italic mx-auto font-neue md:w-full relative"
    >
      <img
        src="../assets/images/noisette.png"
        class="md:hidden w-12 absolute right-0 -top-40"
      />
      <img
        src="../assets/images/pepite2.png"
        class="md:hidden w-4 absolute -right-2 -top-28 rotate-[30deg]"
      />
      *Voir
      <a
        href="https://oxoformdocs.fra1.digitaloceanspaces.com/6ab5213da6298f733bc73670/reglement.pdf"
        class="underline"
        target="_blank"
        >règlement complet</a
      >
      du jeu.<br />
      **Produits participants : Kinder<sup>&reg;</sup> Joy x3, Kinder<sup
        >&reg;</sup
      >
      Bueno White x6, Kinder<sup>&reg;</sup> Maxi x20, Kinder<sup>&reg;</sup>
      Tronky x5, Kinder<sup>&reg;</sup> Cards x5, Kinder<sup>&reg;</sup> Crunchy
      cookies x8, Nutella<sup>&reg;</sup>
      Bready x6.
    </p>
  </main>
</template>

<style scoped>
.points {
  @apply bg-white absolute h-6 w-6 pt-1 text-red-900 flex justify-center items-center rounded-full text-xl font-bold -left-8;
}
</style>
<script>
export default {
  data() {
    return {
      queryParams: {},
    };
  },
  created() {
    this.queryParams = this.$route.query;
    if (this.queryParams.code_unique) {
      window.code = this.queryParams.code_unique;
      window.code_unique = this.queryParams.code_unique;
    }
  },
  methods: {
    getParameter(name) {
      return this.$route.query[name];
    },
  },
};
</script>
